/* eslint-disable react/prop-types */
import { Col, Row } from 'antd';
import Container from 'components/Containers/Container';
import React from 'react';

import Profile from 'modules/Auth/components/UserProfile/components/Profile';
import UpdateProfile from 'modules/Auth/components/UserProfile/components/UpdateProfile';

export default () => {
  return (
    <React.Fragment>
      <Container name='Trang cá nhân' parentName='Sách số'>
        <Row gutter={[24, 24]}>
          <Col xs={24} sm={24} lg={16}>
            <UpdateProfile />
          </Col>
          <Col xs={24} sm={24} lg={8}>
            <Profile />
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};
